<template>
    <div class="main" id="mainwrap">
        <download-Popup />
        <p v-if="isOperamini" class="operamini-tips">
            Untuk memberi Anda pengalaman yang lebih baik, silakan unduh aplikasi profesional kami.
        </p>

        <headerTitle
          v-if="articleBody.title"
          :title="articleBody.title"
          :time="articleBody.time"
          :writer="articleBody.writer"
          :afhao="articleBody.afh_info"
        />

        <articleCon v-if="articleBody.body" :bodydata="articleBody.body" :afhao="articleBody.afh_info" />
        <infos v-if="articleBody.infos" :infos="articleBody.infos" />

        <template v-if="loadItem">
            <relatedNews :articleId="articleBody.article_id" />
            <comments :articleId="articleBody.article_id" :time="3000" />
        </template>

        <downloadFooter v-if="bodyLoad&&loadItem&&!isInApp" v-once text="Download All Sepakbola for more comments" />
        <div class="links">
            Tautan：<a href="http://footballlive.cc/">Live Sepak Bola | Hasil Sepak Bola | Pemain yang Mencetak Gol</a>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import downloadFooter from '@/components/downloadFooter.vue';
    import headerTitle from '@/components/headerTitle.vue';
    import articleCon from '@/components/articleCon.vue';
    import infos from '@/components/infos.vue';
    import relatedNews from '@/components/relatedNews.vue';
    import comments from '@/components/comments.vue';
    import downloadPopup from '@/components/downloadPopup.vue';

    export default {
        name: 'app',
        components: {
             downloadFooter,
             headerTitle,
             articleCon,
             infos,
             relatedNews,
             comments,
             downloadPopup
        },
        data () {
            return {
                imgMode: 'loading',
                isInApp: process.env.VUE_ENV === 'server' ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL,
                title: '',
                time: '',
                writer: '',
                copyright: '',
                new_video_detail: 0,
                con: [],
                infos: {
                    channels: [],
                    column: {}
                },
                article_id: parseInt(this.$route.params.id, 10),
                bodyLoad: false,
                tag: [],
                loadItem: false,
                isOperamini: false
            };
        },
        computed: {
            articleBody () {
                return this.$store.state.articlebody[this.article_id] || {};
            },
            relative () {
                return this.$store.state.relative[this.article_id];
            },
            comments () {
                return this.$store.state.comments[this.article_id];
            }
        },
        asyncData ({ store, route: { params: { id } } }) {
            // 此函数会在组件实例化之前执行，故直接将store,route传入；
            if (id) {
                return store.dispatch('FETCH_ARTICLEBODY', { article_id: id });
            } else {
                return Promise.reject();
            }
        },
        head () {
            const HOST = process.env.NODE_ENV === 'production' ? 'https://m-yinni.allsepakbola.net' : 'https://beta-m-yinni.allfootballapp.com';
            const title = this.articleBody.title + '| All Sepakbola';
            const match = this.articleBody.body && this.articleBody.body.match(/<img[^>]+data-src\="([^"]+)"/);
            const p1 = this.articleBody.body && this.articleBody.body.match(/<(.*?)>(.*?)<\/\1>/);
            const shareUrl = HOST + this.$route.fullPath;
            const shareImg = match && match[1] ? match[1] : 'http://img.allfootballapp.com/www/M00/52/A6/rB8CLF1hHy2AWL55AAm0BGPys88585.png';
            const description = p1 && p1[2] ? p1[2] : 'Visit All Sepakbola to get football news, live scores, highlights, videos and commentary for EPL, La Liga, Bundesliga, Serie A';
            let keywords = 'All Sepakbola';

            if (this.articleBody.infos && this.articleBody.infos.channels) {
                keywords = this.articleBody.infos.channels.map(item => item.tag).join(',');
            }
            const link = [];
            if (this.$route.fullPath && this.$route.fullPath.indexOf('/news' === 0)) {
                link.push({
                    rel: 'amphtml',
                    href: HOST + '/amp' + this.$route.fullPath
                });
            }

            return {
                title,
                link,
                meta: [
                    {
                        name: 'description',
                        content: description.replace(/<(.*?)>/g, '')
                    },
                    {
                        name: 'keywords',
                        content: keywords
                    },
                    { name: 'twitter:card', content: 'summary_large_image' },
                    { name: 'twitter:site', content: '@allfootballapp' },
                    { name: 'twitter:creator', content: '@allfootballapp' },
                    { name: 'twitter:app:id:ipad', content: '' },
                    { name: 'twitter:title', content: title },
                    { name: 'twitter:description', content: title },
                    { name: 'twitter:image', content: shareImg },
                    // facebook
                    { name: 'fb:app_id', content: 'summary_large_image' },
                    { name: 'og:url', content: shareUrl },
                    { name: 'og:type', content: 'article' },

                    // for twiter and facebook
                    { name: 'og:title', content: title },
                    { name: 'og:description', content: title },
                    { name: 'og:image', content: shareImg },
                    { name: 'og:site_name', content: 'AllfootballOfficial' }
                ]
            };
        },

        mounted () {
            // 分享页历史重置
            const query = this.$route.query || {};
            if (window.history && query.type && query.type === 'share') {
                const fullPath = this.$route.fullPath;
                history.replaceState(null, 'share', '/home?utm_source=APP_SHARE');
                history.pushState(null, 'share', fullPath);

                window.addEventListener('popstate', function (event) {
                    if (location.pathname !== '/news') {
                        location.reload();
                    }
                });
            }

            let mainwrap = document.getElementById('mainwrap');
            console.log('页面高度：' + mainwrap.offsetHeight);
            // 页面跳转到文章页 滚动条位置受前一页影响
            if (!this.articleBody) return;

            this.bodyLoad = true;

            if (!this.articleBody.infos) return;

            let channels = this.articleBody.infos.channels;
            for (let i = 0, len = channels.length; i < len; i++) {
                Vue.set(this.infos.channels, i, channels[i]);
            }
            Vue.set(this.infos, 'column', this.articleBody.infos.column);

            if (mainwrap.offsetHeight - window.screen.height - 100 > 0) {
                this.loadItem = false;
                window.addEventListener('scroll', this.loadmoreFn, false);
            } else {
                this.loadItem = true;
            }
            let utilObj = require('@/util/util.js');
            utilObj.timeForInOut();
            this.isOperamini = false;
        },

        methods: {
            loadmoreFn () {
                if ((document.documentElement.scrollTop || document.body.scrollTop) > 10) {
                    if (this.loadItem) return;
                    this.loadItem = true;
                    window.removeEventListener('scroll', this.loadmoreFn, false);
                }
            }
        }
    };
</script>

<style scoped lang="less">
.operamini-tips {
  background: #ffff00;
  text-align: center;
  font-weight: bold;
}

.links {
  font-size: 14px;
  padding: 0 15px 0 15px;
  color: #fff;

  a {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// AppNews.vue?8ae6911c